import { CommonModule, NgIf } from '@angular/common';
import {
  Component,
  Input,
  HostBinding,
  HostListener,
  EventEmitter,
  Output,
} from '@angular/core';
import { FormBuilder, FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { HomeService } from '../../home.service';
import {
  AppPopupData,
  PopupType,
} from '../../../../../widgets/app-popup/app-popup.component';
import { IraAlertPopupComponent } from '../../../../../widgets/ira-alert-popup/ira-alert-popup.component';
@Component({
  selector: 'app-file-upload',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule, NgIf],
  templateUrl: './file-upload.component.html',
  styleUrl: './file-upload.component.scss',
})
export class FileUploadComponent {
  private isHovered = false;
  fileInput: FormControl;
  isBasketHovered = false;
  fileToUpload: any;
  isFieldsDisabled: boolean;
  @Output()
  fileChosen = new EventEmitter<File>();

  @Input()
  set image(image: any) {
    this.fileToUpload = image;
    this.fileInput.setValue('');
  }

  @HostBinding('class.filled')
  get filled(): boolean {
    return !!this.fileToUpload;
  }

  ngOnInit() {
    this.homeService.productData$.subscribe((data) => {
      console.log('data', data);
      this.isFieldsDisabled = data;
    });
  }

  get uploadIcon(): string {
    let icon = './assets/images/icons/upload-icon-large.png';
    if (this.isHovered) {
      icon = './assets/images/icons/upload-icon-large.png';
    }
    return icon;
  }

  get basketIcon(): string {
    if (this.isBasketHovered) {
      return './assets/images/icons/basket-icon-hover.svg';
    } else {
      return './assets/images/icons/basket-icon.svg';
    }
  }

  get fileType(): any {
    if (this.fileToUpload) {
      return this.fileToUpload.name.split('.').pop();
    } else {
      return '';
    }
  }

  constructor(
    private homeService: HomeService,
    formBuilder: FormBuilder,
    private dialog: MatDialog
  ) {
    this.fileInput = formBuilder.control({
      value: '',
      disabled: this.disabled,
    });
  }

  @Input()
  @HostBinding('class.disabled')
  disabled: boolean;
  @HostBinding('class.ripple')
  // get ripple() {
  //   return !this.disabled;
  // }
  @HostListener('mouseover')
  onMouseOver() {
    this.isHovered = true;
  }

  @HostListener('mouseout') onMouseOut() {
    this.isHovered = false;
  }

  handleFileInput(e: any) {
    const files: any = e.target.files;
    if (files.length > 0) {
      const file = files.item(0);
      const fileType = file.type;
      const fileName = file.name;
      const fileExtension = fileName.split('.').pop().toLowerCase();

      // Allowed extensions
      const allowedExtensions = [
        'jpg',
        'png',
        'jpeg',
        'pdf',
        'docx',
        'pptx',
        'ppt',
        'doc',
        'tif',
        'tiff',
      ];

      if (!allowedExtensions.includes(fileExtension)) {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        (dialogConfig.height = '190px'),
          (dialogConfig.width = '390px'),
          (dialogConfig.data = {
            message:
              'This File Type Is Not Supported. Please Upload a Supported File Type.',
            buttons: [{ id: 'OK', text: 'OK' }],
            submitButtonId: 'OK',
            messageType: 'fileUpload',
            type: PopupType.ERROR,
          } as any);
        this.dialog
          .open(IraAlertPopupComponent, dialogConfig)
          .afterClosed()
          .subscribe((response) => {});

        return;
      }

      this.fileToUpload = file;
      this.homeService.isImageStateSubject.next(true);
      this.fileChosen.emit(this.fileToUpload);
    }
  }

  clear() {
    this.image = null;
  }
}
